module.exports = __webpack_public_path__ + "img/cx.c0bed957.svg";